import React from 'react';
import PropTypes from 'prop-types';

const DropShadowFilter = ({ direction }) => {
  let dx = 0;
  let dy = 0;

  switch (direction) {
    case 'left':
    case 'Left':
    case 'LEFT':
      dx = -30;
      break;
    case 'right':
    case 'Right':
    case 'RIGHT':
      dx = 30;
      break;
    case 'up':
    case 'Up':
    case 'UP':
      dy = -30;
      break;
    case 'down':
    case 'Down':
    case 'DOWN':
    default:
      dy = 30;
      break;
  }

  return (
    <div className="syos-drop-shadow-box">
      <svg xmlns="http://www.w3.org/2000/svg">
        <filter x="0" y="0" id="dropShadow">
          <feGaussianBlur in="SourceAlpha" stdDeviation="15" />
          <feOffset dx={dx} dy={dy} result="offsetblur" />
          <feFlood floodColor="rgb(0,0,0)" floodOpacity="0.175" />
          <feComposite in2="offsetblur" operator="in" />
          <feMerge>
            <feMergeNode />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
      </svg>
      <style>
        {
          '\
        #seatmap> g {\
          filter: url(#dropShadow);\
        }\
     '
        }
      </style>
    </div>
  );
};

DropShadowFilter.propTypes = {
  direction: PropTypes.string
};

export default DropShadowFilter;



// WEBPACK FOOTER //
// ./src/javascripts/components/DropShadowFilter.js